import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=06710f54&"
import script from "./RuleForm.vue?vue&type=script&lang=js&"
export * from "./RuleForm.vue?vue&type=script&lang=js&"
import style0 from "./RuleForm.vue?vue&type=style&index=0&id=06710f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports